import { RichTextArea } from '@app/ui';
import { createRichTextAreaAutoFocusPlugin } from '@app/main/plugins';

export const NoteTemplateRichTextAreaComponent = (autofocus?: boolean) => {
  return RichTextArea.extend(RichTextArea, createRichTextAreaAutoFocusPlugin(autofocus));
};
